import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n";
import { Button } from "@/components/ui/button";

const KEY = "pronet-cookie-consent";

export default function CookieBanner() {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let saved = null;
    try {
      saved = window.localStorage.getItem(KEY);
    } catch (e) {}
    if (!saved) {
      const id = setTimeout(() => setShow(true), 1400);
      return () => clearTimeout(id);
    }
  }, []);

  const choose = (value) => {
    try {
      window.localStorage.setItem(KEY, value);
    } catch (e) {}
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="glass fixed inset-x-4 bottom-4 z-[70] mx-auto flex max-w-3xl flex-col items-start gap-4 rounded-2xl p-5 shadow-[0_16px_50px_rgba(2,6,23,0.7)] sm:flex-row sm:items-center"
        >
          <p className="flex-1 text-xs leading-relaxed text-slate-300" data-testid="cookie-text">
            {t.cookies.text}{" "}
            <Link
              to="/privacy"
              data-testid="cookie-policy-link"
              className="font-semibold text-orange-300 underline underline-offset-2 transition-colors hover:text-orange-200"
            >
              {t.cookies.policy}
            </Link>
          </p>
          <div className="flex shrink-0 gap-2">
            <Button
              data-testid="cookie-decline"
              onClick={() => choose("rejected")}
              variant="ghost"
              className="h-9 rounded-full border border-slate-600/60 px-4 text-xs text-slate-300 hover:text-slate-100"
            >
              {t.cookies.decline}
            </Button>
            <Button
              data-testid="cookie-accept"
              onClick={() => choose("accepted")}
              className="h-9 rounded-full bg-orange-400 px-4 text-xs font-semibold text-slate-950 hover:bg-orange-300"
            >
              {t.cookies.accept}
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
